import { render, staticRenderFns } from "./page-invitation.vue?vue&type=template&id=fd7b3c60&"
import script from "./page-invitation.vue?vue&type=script&lang=ts&"
export * from "./page-invitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./page-invitation.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports